import { render } from "./Income.vue?vue&type=template&id=6cb26efc&scoped=true"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"

import "./Income.vue?vue&type=style&index=0&id=6cb26efc&scoped=true&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb26efc"]])

export default __exports__